import { render, staticRenderFns } from "./WebHostingMailboxes.vue?vue&type=template&id=093ab168&scoped=true&"
import script from "./WebHostingMailboxes.vue?vue&type=script&lang=js&"
export * from "./WebHostingMailboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ab168",
  null
  
)

export default component.exports